import { gql } from '__generated__';

export default gql(`
  mutation EditParticipantField($input: EditParticipantFieldInput!) {
    editParticipantField(input: $input) {
      ...GetFieldsParticipantField
    }
  }
`);
